import I18n from "../../i18n"

export default function btnOpHome(id:string,label:string,imgSrc:string):string{
    return `
        <button id="${id}" type="button" class="btn-op-home">
            <img src="${imgSrc}" alt="btn op home logo" class="img-logo">
            <span class="label-btn-op">${I18n.apply(label)}</span>
        </buttom>
    `;
}